import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { mergeMap, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ResourceUtil } from '../app/shared/util/resource-util';
import { IBaryTableFetchService, TableOptions } from './i-bary-table-fetch-service';
import { createRequestOption } from '../app/shared/util/request-util';
import { CurrentDataService } from './current-data-service';
import { PricingItemViewType } from '../models/types/pricing-item-view.type';
import { SearchPricingModel } from '../models/search-pricing.model';
import { EligiblePricingItems } from '../models/eligible-pricing-items.model';

@Injectable({ providedIn: 'root' })
export class ModeratorPricingItemsService implements IBaryTableFetchService<PricingItemViewType> {
  readonly http = inject(HttpClient);
  readonly currentDataService = inject(CurrentDataService);

  public fillDataToShow(entities: PricingItemViewType[]): Observable<PricingItemViewType[]> {
    return of(entities);
  }

  public query(req?: any, serviceOptions?: TableOptions): Observable<HttpResponse<PricingItemViewType[]>> {
    const options = createRequestOption(req);
    return this.currentDataService.getCustomer().pipe(
      take(1),
      mergeMap(customer => {
        let url = ResourceUtil.asModeratorURL('/pricing-item', customer!);
        if (serviceOptions?.appendPath) {
          url += serviceOptions.appendPath;
        }
        if (serviceOptions?.identifier) {
          url += '/' + serviceOptions.identifier;
        }
        return this.http.get<PricingItemViewType[]>(url, {
          params: options,
          observe: 'response',
        });
      })
    );
  }

  public search(searchPricingModel: SearchPricingModel): Observable<HttpResponse<EligiblePricingItems>> {
    return this.currentDataService.getCustomer().pipe(
      take(1),
      mergeMap(customer =>
        this.http.post<EligiblePricingItems>(ResourceUtil.asModeratorURL('/pricing-search', customer!), searchPricingModel, {
          observe: 'response',
        })
      )
    );
  }

  public delete(req?: any, serviceOptions?: TableOptions): Observable<HttpResponse<any>> {
    const options = createRequestOption(req);
    return this.currentDataService.getCustomer().pipe(
      take(1),
      mergeMap(customer => {
        let url = ResourceUtil.asModeratorURL('/pricing-item', customer!);
        if (serviceOptions?.appendPath) {
          url += serviceOptions.appendPath;
        }
        if (serviceOptions?.identifier) {
          url += '/' + serviceOptions.identifier;
        }
        return this.http.delete(url, {
          params: options,
          observe: 'response',
        });
      })
    );
  }

  public hasPricingItems(offerId: number): Observable<boolean> {
    return this.currentDataService.getCustomer().pipe(
      take(1),
      mergeMap(customer => this.http.get<boolean>(`${ResourceUtil.asModeratorURL('/pricing-item', customer!)}/has-pricing-items/${offerId}`))
    );
  }
}
